export default {
  check: '/v3/invite/courier/invite/bind/check', // 扫码绑定校验
  registerBind: '/v3/invite/courier/invite/bind', // 注册接口
  sendSmsCode: '/passport/captcha/sendMobileCaptcha', // 发短信接口
  getCodeBySms: '/passport/login/getCodeBySms', // 校验短信接口
  getBanner: '/v3/invite/courier/invite/recommended/banner', // 获取banner
  courierAge: '/v3/recruit/courierAge' // 查询年龄
}
